import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import * as f from '../logic';
import PauseIcon from '../../HOME/SVG/PauseIcon';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import { goToPage, showLeaderboards, requestSurrender, requestResetStats } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { showHelp, pause } from '../REDUX/actions';
import { RED } from '../../HOME/const';

class Toolbar extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  board = () => (this.props.board.current ? this.props.board.current : null);

  handleSurrender = e => {
    this.props.hideOptions();
    this.props.showHelp(false);
    this.handlePause();

    const board = this.board();

    if (f.canSurrender(this.props)) {
      if (board.gameOver()) {
        board.restart();
      } else {
        this.props.requestSurrender(true);
      }

      this.props.requestResetStats(false);
    }
  };

  handleLeaders = () => {
    this.props.hideOptions();
    this.props.showHelp(false);
    this.handlePause();

    this.props.showLeaderboards();
  };

  handlePause = () => {
    const board = this.board();

    if (board.state.msecs > 0 && !board.gameOver()) {
      this.props.pause(true);
    }
  };

  handleOptions = () => {
    this.handlePause();
    this.props.onClickOptions();
  };

  render() {
    const xmax = windowSize().x;
    const margin = Math.max(5, Math.min(10, xmax / 100));
    const board = this.board();

    const styles = {
      button: { marginLeft: margin, marginRight: margin },
    };

    return (
      <div className="toolbar">
        {!this.props.paused && board && !board.gameOver() && board.state ? (
          <span
            className={`toolbar-button ${board.state.msecs > 0 ? '' : 'toolbar-button-disabled'}`}
            style={styles.button}
            onClick={this.handlePause}>
            <PauseIcon width="36" color={RED} />
          </span>
        ) : null}
        <span
          className={`toolbar-button ${f.canSurrender(this.props) ? '' : 'toolbar-button-disabled'}`}
          style={styles.button}
          onClick={this.handleSurrender}>
          <RestartIcon width="36" />
        </span>
        <span className="toolbar-button" style={styles.button} onClick={this.handleLeaders}>
          <TrophyIcon width="36" />
        </span>
        <span className="toolbar-button" style={styles.button} onClick={this.handleOptions}>
          <OptionsIcon width="36" id="options-button" />
        </span>
      </div>
    );
  }
}

function mapStateToProps({ mt, common }) {
  return { ...mt, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender, goToPage, showLeaderboards, showHelp, pause },
  null,
  { forwardRef: true }
)(Toolbar);
